import { legacy_createStore as createStore, combineReducers } from 'redux';
import { globalReducer } from './reducer';
import {PlansetReducer} from "../pages/Planset/PlansetReducer";
import { SalesProposalReducer } from "../pages/SalesProposal/SalesProposalReducer";
import { PTOReducer } from "../pages/PTO/PTOReducer"
import { PEStampReducer } from "../pages/PEStamp/PEStampReducer";

const rootReducer = (state, action) => ({
  ...globalReducer(state, action),       // old reducer updates top-level state
  planset: PlansetReducer(state?.planset, action), // new reducer under "planset"
  salesProposal: SalesProposalReducer(state?.salesProposal, action), // new reducer under "salesProposal"
  pto: PTOReducer(state?.pto, action), // new reducer under "pto"
  peStamp: PEStampReducer(state?.peStamp, action),
});

export const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
